import { render, staticRenderFns } from "./VlModalShowFile.vue?vue&type=template&id=d65b41ba&scoped=true&"
import script from "./VlModalShowFile.vue?vue&type=script&lang=js&"
export * from "./VlModalShowFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d65b41ba",
  null
  
)

export default component.exports